"use client";
export default function ErrorPage({ reset }: { reset: () => void }) {
  return <main className="placeholder placeholder--giant"><span className="giant giant--page" aria-hidden="true">歇</span><p className="eyebrow">公开门户</p><h1>公开内容暂时无法读取</h1><p>请稍后重试。</p><button type="button" onClick={reset}>重新读取</button></main>;
}
